import { createBrowserRouter } from "react-router";
import AuthPage from "./pages/AuthPage";
import UploadPage from "./pages/UploadPage";
import ErrorBoundary from "./components/ErrorBoundary";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: AuthPage,
    ErrorBoundary: ErrorBoundary,
  },
  {
    path: "/auth",
    Component: AuthPage,
    ErrorBoundary: ErrorBoundary,
  },
  {
    path: "/upload",
    Component: UploadPage,
    ErrorBoundary: ErrorBoundary,
  },
  {
    path: "*",
    Component: AuthPage, // Fallback til AuthPage for ukjente routes
    ErrorBoundary: ErrorBoundary,
  },
]);